import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import { CancelIcon, PlusIcon, SearchesCIcon } from "../assets/Icons";
import apiClient from "../apiClient";
import { SSO_URL } from "../env";
import { FETCH_ENUM_TYPES, GET_DIRECTORY_LIST, GET_GROUP_LIST } from "../apiClient/apiEndpoints";
import { setDefaultTextForImage } from "../components/common/DefaulTextForAvatar";
import NoDataFound from "../components/common/NoDataFound";

const GroupList = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [directories, setDirectories] = useState([]);
  const [groups, setGroups] = useState([]);
  const [channelTypes, setChannelTypes] = useState([]);

  const [newChannelDetails, setNewChannelDetails] = useState({
    name: null,
    type: null,
    directory: null,
    group: null,
  });

  const fetchDirectories = async () => {
    try {
      const details = await apiClient.get(`${SSO_URL}${GET_DIRECTORY_LIST}`);
      setDirectories(details);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchChannelsType = async () => {
    try {
      let data = await apiClient.get(`${SSO_URL}${FETCH_ENUM_TYPES}/channelType`);
      const { PRIMARY, ...others } = data;
      setChannelTypes(Object.keys(others));
    } catch (error) {
      console.log(error);
    }
  };

  const fetchGroups = async () => {
    try {
      setLoading(true);
      const response = await apiClient.get(`${SSO_URL}${GET_GROUP_LIST}`);
      setGroups(response);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDirectories();
    fetchChannelsType();
    fetchGroups();
  }, []);

  useEffect(() => {
    if (state?.directoryId && directories?.length > 0) {
      const currentDir = directories.find((item) => item.uuid === state.directoryId);
      setNewChannelDetails((prev) => ({
        ...prev,
        directory: { label: currentDir.name, value: currentDir.uuid },
      }));
    }
  }, [state?.directoryId, directories]);

  const filteredGroups = useMemo(() => {
    if (!search) return groups;
    return groups.filter((e) => e?.name?.toLowerCase()?.includes(search?.toLowerCase()));
  }, [search, groups]);

  const skeletonCards = Array.from({ length: 4 }, (_, i) => (
    <div key={`skeleton-${i}`} className="tilecard p-0 mb-3" style={{ outline: "none" }}>
      <div className="groupcardesign">
        <div className="avatarimg p-0" style={{ outlineColor: "#ffffff00" }}>
          <Skeleton circle height="100%" width="100%" className="m-0 p-0" />
        </div>
        <h6 className="groupname"> </h6>
        <div className="groupusercount d-flex flex-column gap-2">
          <p>
            <Skeleton width="10vw" className="my-1" />
          </p>
          <p>
            <Skeleton width="10vw" className="my-1" />
          </p>
        </div>
      </div>
    </div>
  ));

  return (
    <div className="container-fluid p-4 pt-2">
      <div className="add-info">
        <div className="page-title p-0">
          <h5>Group List</h5>
        </div>
        <div className="row">
          <div className="col-lg-6 mt-3">
            <form className="app-search d-flex justify-content-start me-2">
              <div className="position-relative">
                <SearchesCIcon />
                {search.length > 0 && (
                  <span className="searchiconcancel" onClick={() => setSearch("")}>
                    <CancelIcon />
                  </span>
                )}
                <input
                  type="text"
                  placeholder="Search"
                  className="form-control"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </form>
          </div>
          <div className="col-lg-6 d-flex align-items-center justify-content-end">
            <button className="DefaultRedBtn" onClick={() => navigate("/dashboard/groups/list/create-group")}>
              <PlusIcon /> Create Group
            </button>
          </div>
        </div>

        <div className="usergrouplist">
          {filteredGroups.length > 0 ? (
            <div className="course-tiles mt-2">
              {loading
                ? skeletonCards
                : filteredGroups.map((item) => (
                    <div
                      key={item.uuid}
                      // onClick={() => setNewChannelDetails((prev) => ({ ...prev, group: item.uuid }))}
                      // onClick={() => {
                      //   setNewChannelDetails((prev) => ({ ...prev, group: item.uuid }));
                      //   navigate("/dashboard/groups-list/create-group", {
                      //     state: {
                      //       groupId: item.uuid,
                      //       groupName: item.name,
                      //       avatar: item.avatar,
                      //     },
                      //   });
                      // }}
                      className={newChannelDetails.group === item.uuid ? "tilecard selected-group p-0" : "tilecard p-0"}
                    >
                      <div className="groupcardesign">
                        <div className="avatarimg">
                          {item?.avatar ? (
                            <img src={item.avatar} alt={item.name} title={item.name} referrerPolicy="no-referrer" />
                          ) : (
                            <span>{setDefaultTextForImage(item?.name)}</span>
                          )}
                        </div>
                        <h6 className="groupname">{item.name}</h6>
                      </div>
                    </div>
                  ))}
            </div>
          ) : loading ? (
            <NoDataFound text="Fetching Data..." />
          ) : (
            <NoDataFound text="No group  found" />
          )}
        </div>
      </div>
    </div>
  );
};

export default GroupList;
